import ArtifactGroupType from "../base/ArtifactGroupType";


const StringsOfTheSkald = {
  id: '118',
  name: 'Strings Of The Skald',
  groupIcon: 'EchoesOfTheNorth',
  type: ArtifactGroupType.ECHOES_OF_THE_NORTH,
  icon: 'StringsOfTheSkald',
  power: 25,
  gameId: 'StringsOfTheSkald'
};

export default StringsOfTheSkald;
